export default __webpack_public_path__ + "static/media/todolist2 clone.debb10ea.png";